// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detailSection .item.width100[data-v-69e1265d] {\n  -webkit-box-flex: 0 !important;\n      -ms-flex: 0 0 100% !important;\n          flex: 0 0 100% !important;\n  width: 100% !important;\n}", ""]);
// Exports
module.exports = exports;
